export default "__VITE_ASSET__CTuNfjfw__"